import { sanguine } from '@cogneed/react-utils';
import { styled, Typography } from '@mui/material';

const MutationError = styled(Typography)({
  color: sanguine[500],
  fontSize: 12,
  lineHeight: '20px',
  marginTop: 4,
});

export default MutationError;
